import { actionsFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { OrganizationSettingsTranslation } from 'api/admin/models/OrganizationSettingsTranslation';
import { GetAdminOrganizationSettingsTranslationParamsType } from './types';

export const getAdminOrganizationSettingsTranslation = actionsFactories.createGetManyActionsFactory<
  EntityType<OrganizationSettingsTranslation>,
  GetAdminOrganizationSettingsTranslationParamsType
>()(
  'GET_ADMIN_ORGANIZATION_SETTINGS_TRANSLATION_REQUEST',
  'GET_ADMIN_ORGANIZATION_SETTINGS_TRANSLATION_SUCCESS',
  'GET_ADMIN_ORGANIZATION_SETTINGS_TRANSLATION_FAILURE',
  'GET_ADMIN_ORGANIZATION_SETTINGS_TRANSLATION_RESET',
);

export const updateAdminOrganizationSettingsTranslation = actionsFactories.createUpdateOneActionsFactory<
  EntityType<OrganizationSettingsTranslation>,
  GetAdminOrganizationSettingsTranslationParamsType
>()(
  'UPDATE_ADMIN_ORGANIZATION_SETTINGS_TRANSLATION_REQUEST',
  'UPDATE_ADMIN_ORGANIZATION_SETTINGS_TRANSLATION_SUCCESS',
  'UPDATE_ADMIN_ORGANIZATION_SETTINGS_TRANSLATION_FAILURE',
  'UPDATE_ADMIN_ORGANIZATION_SETTINGS_TRANSLATION_RESET',
);
